/**
 * Roles limited to assigned warehouses — must not see estate-wide ops data.
 * Keep in sync with `SCOPED_LOCATION_ROLES` in `services/userLocation.service.ts`.
 */
export const SCOPED_LOCATION_ROLES = new Set([
  'hubManager',
  'spokeManager',
  'gigWorker',
]);

export function hasLocationScopedRole(roles: string[] | null | undefined): boolean {
  if (!roles || roles.length === 0) return false;
  return roles.some((role) => SCOPED_LOCATION_ROLES.has(role));
}
